'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const EntityDictionary=require('pulsar-utils/dist-es6/domain/entityDictionary');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');let

PersonModel=function(){
function PersonModel(id,firstName,lastName,employeeId){_classCallCheck(this,PersonModel);
this._id=id;
this._isSelected=!1;
this._firstName=firstName;
this._lastName=lastName;
this._employeeId=employeeId;
}_createClass(PersonModel,[{key:'id',get:function()
{
return this._id;
}},{key:'firstName',get:function()
{
return this._firstName;
}},{key:'lastName',get:function()
{
return this._lastName;
}},{key:'employeeId',get:function()
{
return this._employeeId;
}},{key:'displayName',get:function()
{
return`${this.lastName}, ${this.firstName}`;
}},{key:'isSelected',get:function()

{
return this._isSelected;
},set:function(

isSelected){
this._isSelected=isSelected;
}}]);return PersonModel}();


const BaseColumnDefinitions=[{
label:'Name',
isInitiallyActive:!0,
defaultAscending:!0,
orderBy:['displayName'],
columnClass:'name-column'},
{
label:'Employee Code',
defaultAscending:!0,
orderBy:['employeeId'],
columnClass:'employee-code-column'}];


const GroupColumnDefinitions=[{
columnClass:'select-column'}].

concat(BaseColumnDefinitions);let

GroupsController=(_class=function(_BaseController){_inherits(GroupsController,_BaseController);
function GroupsController(
$scope,
$state,
$timeout,
$modal,
groupBasedDataHelperService,
personService,
groupsCommandAndQueryService,
groupsPopulationService,
organizationDefaultsService,
breadcrumbsService,
socketService,
groupUpdateErrorHandlingService,
userService,
groupTreeService,
uncaughtErrorHandler){_classCallCheck(this,GroupsController);var _this=_possibleConstructorReturn(this,

_BaseController.call(this,uncaughtErrorHandler));
_this._$state=$state;
_this._$scope=$scope;
_this._$modal=$modal;
_this._$timeout=$timeout;
_this._personService=personService;
_this._groupsCommandAndQueryService=groupsCommandAndQueryService;
_this._groupsPopulationService=groupsPopulationService;
_this._organizationDefaultsService=organizationDefaultsService;
_this._socketService=socketService;
_this._groupUpdateErrorHandlingService=groupUpdateErrorHandlingService;
_this._groupTreeService=groupTreeService;

_this._$scope.$watch('controller.selectedGroup',function(newlySelectedGroup,oldSelectedGroup){
if(_.exists(newlySelectedGroup)){
_this._$state.go('fdc.features.groups',{
groupId:newlySelectedGroup.id});

}
});


groupBasedDataHelperService.clearCaches();

breadcrumbsService.startTrail('Groups');

_this._reload=_this._reload.bind(_this);
_this._reload(_this._$state.params.groupId);return _this;
}GroupsController.prototype.

_createEveryoneGroupModel=function _createEveryoneGroupModel(persons,organizationThresholds){
return{
name:'Organization',
isSpecialGroupContainingWholeOrg:!0,
id:null,
persons:persons,
fatigueThreshold:organizationThresholds.fatigueThreshold,
deviationThreshold:organizationThresholds.deviationThreshold,
children:[]};

};GroupsController.prototype.


_reload=function(){var ref=_asyncToGenerator(function*(groupIdToSelect){var _this2=this;
let[rawPersons,rawGroupTree,organizationThresholds]=yield Promise.all([
this._personService.getAllPersons(),
this._groupsCommandAndQueryService.getGroupTree(),
this._organizationDefaultsService.getOrganizationThresholds()]);


this._allPersons=rawPersons.map(function(p){return new PersonModel(p.id,p.firstName,p.lastName,p.employeeId)});
this._defaultFatigueThreshold=organizationThresholds.fatigueThreshold;
this._defaultDeviationThreshold=organizationThresholds.deviationThreshold;
let everyoneGroup=this._createEveryoneGroupModel(this._allPersons,organizationThresholds);

let currentSelections={};
if(_.exists(this._groupTree)){
for(let group of treeUtils.flatten(this._groupTree)){
for(let person of group.persons){
currentSelections[`${group.id}${person.id}`]=person.isSelected;
}
}
}

let populatedGroups=this._groupsPopulationService.populate(rawGroupTree,EntityDictionary.create(this._allPersons));

for(let group of treeUtils.flatten(populatedGroups)){
group.isSpecialGroupContainingWholeOrg=!1;
for(let person of group.persons){
person.isSelected=currentSelections[`${group.id}${person.id}`]||!1;
}
}

yield new Promise(function(resolve){
_this2._$timeout(function(){
_this2._groupTree=[everyoneGroup].concat(populatedGroups);
_this2._groupTreeService.groupTree=_this2._groupTree;
if(_.exists(groupIdToSelect)){
_this2._groupTreeService.selectGroupWithId(groupIdToSelect,{forceExpansion:!0});
}
resolve();
});
});
});function _reload(groupIdToSelect){return ref.apply(this,arguments)}return _reload}();GroupsController.prototype.

















onRowClick=function onRowClick(item,$event){
if(_.get($event,'target.tagName')==='INPUT'){


$event.stopPropagation();
return;
}
this._$timeout(function(){return item.isSelected=!item.isSelected});
};GroupsController.prototype.

editGroup=function editGroup(){var _this3=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/editGroupModalView',
controller:'EditGroupModalController as controller',
resolve:{
resolvedParameters:function(){
return{
group:_this3.selectedGroup,
onGroupSaved:_this3._reload,
onGroupDeleted:_this3._reload};

}}});


};GroupsController.prototype.

createNewGroup=function createNewGroup(){var _this4=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/createGroupModalView',
controller:'CreateGroupModalController as controller',
resolve:{
groupTree:function(){return _this4.groupTree.filter(function(group){return!group.isSpecialGroupContainingWholeOrg})},
onGroupCreated:function(){return _this4._reload}}});


};GroupsController.prototype.


removeSelectedPeopleFromGroup=function(){var ref=_asyncToGenerator(function*(){var _this5=this;
let peopleToRemove=this.selectedGroup.persons.filter(function(p){return p.isSelected&&_.includes(_this5.filteredPersons,p)});

const response=yield this._socketService.sendAndWaitForResponse('RemovePersonsFromGroup',{
groupId:this.selectedGroup.id,
personIds:peopleToRemove.map(function(p){return p.id})});


if(!SocketResponse.succeeded(response)){
this._groupUpdateErrorHandlingService.handle(response);
}

yield this._reload(this.selectedGroup.id);
});function removeSelectedPeopleFromGroup(){return ref.apply(this,arguments)}return removeSelectedPeopleFromGroup}();GroupsController.prototype.

addPersonsToGroup=function addPersonsToGroup(){var _this6=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/addPersonsToGroupModalView',
controller:'AddPersonsToGroupModalController as controller',
resolve:{
group:function(){return _this6.selectedGroup},
organizationPersons:function(){return _this6._allPersons},
onPersonsAdded:function(){return _this6._reload}}});


};GroupsController.prototype.

setThreshold=function setThreshold(){var _this7=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/setThresholdModalView',
controller:'SetThresholdModalController as controller',
resolve:{
resolvedParameters:function(){
return{
defaultFatigueThreshold:_this7._defaultFatigueThreshold,
defaultDeviationThreshold:_this7._defaultDeviationThreshold,
group:_this7.selectedGroup,
onThresholdSet:_this7._reload};

}}});


};_createClass(GroupsController,[{key:'selectedGroup',set:function(newlySelectedGroup){this._groupTreeService.selectGroupWithId(newlySelectedGroup.id)},get:function(){return this._groupTreeService.selectedGroup}},{key:'groupTree',get:function(){return this._groupTree}},{key:'anyPersonsSelected',get:function(){return _.some(this.filteredPersons,function(p){return p.isSelected})}},{key:'groupColumnDefinitions',get:function()

{
return GroupColumnDefinitions;
}},{key:'organizationColumnDefinitions',get:function()

{
return BaseColumnDefinitions;
}},{key:'defaultFatigueThreshold',get:function()

{
return _.get(this.groupTree,'0.fatigueThreshold');
}},{key:'defaultDeviationThreshold',get:function()

{
return _.get(this.groupTree,'0.deviationThreshold');
}}]);return GroupsController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_reload',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reload'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'removeSelectedPeopleFromGroup',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'removeSelectedPeopleFromGroup'),_class.prototype)),_class);


module.exports=GroupsController;
//# sourceMappingURL=groupsController.js.map
